<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="documents"
        :footer-props="{ 'items-per-page-options': [20, 30, 40, -1] }"
        item-key="id"
        group-by="type"
      >
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.name="{ item }">
          <v-icon>
            {{ getDocumentIcon(item.name) }}
          </v-icon>
          <span class="ml-2 text-body-2">{{ item.name }}</span>
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.actions="{ item }">
          <v-icon
            @click="downloadDocument(item)"
          >
            mdi-download
          </v-icon>
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:group.header="{ group, headers, toggle, isOpen }">
          <td :colspan="headers.length">
            <v-btn @click="toggle" x-small icon :ref="group">
                <v-icon v-if="isOpen">mdi-minus</v-icon>
                <v-icon v-else>mdi-plus</v-icon>
            </v-btn>
            <span class="mx-5 font-weight-medium">{{ group }}</span>
          </td>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'UserDocuments',
  data: () => ({
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'Type', value: 'type' },
      { text: 'Category', value: 'category' },
      { text: 'Created', value: 'created' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
  }),
  computed: {
    documents() {
      let prospectDocuments = this.$store.state.prospectPacket.documents;
      if (prospectDocuments === null || prospectDocuments === undefined) {
        prospectDocuments = [];
      }
      let benefitsDocuments = this.$store.state.benefitsPacket.documents;
      if (benefitsDocuments === null || benefitsDocuments === undefined) {
        benefitsDocuments = [];
      }
      return prospectDocuments.concat(benefitsDocuments);
    },
  },
  methods: {
    getDocumentIcon(filename) {
      switch (filename.split('.').pop()) {
        case 'txt':
          return 'mdi-text-box';
        case 'docx':
          return 'mdi-file-word';
        case 'doc':
          return 'mdi-file-word';
        case 'pdf':
          return 'mdi-file-document';
        case 'xlsx':
          return 'mdi-file-excel';
        case 'xls':
          return 'mdi-file-excel';
        case 'jpg':
          return 'mdi-file-image';
        case 'jpeg':
          return 'mdi-file-image';
        case 'png':
          return 'mdi-file-image';
        case 'bmp':
          return 'mdi-file-image';
        case 'gif':
          return 'mdi-file-image';
        case 'svg':
          return 'mdi-image-album';
        case 'html':
          return 'mdi-file-code';
        case 'htm':
          return 'mdi-file-code';
        case 'csv':
          return 'mdi-delimited';
        case 'zip':
          return 'mdi-folder-zip';
        case 'rar':
          return 'mdi-folder-zip';
        case '7zip':
          return 'mdi-folder-zip';
        default:
          return 'mdi-file';
      }
    },
    downloadDocument(value) {
      this.$store.dispatch('downloadDocument', value);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
